/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import { User       } from '@/models/user';

import { Logger                } from '@/util/logger';
import {first} from "rxjs/operators";
import {IUserRow} from "@/screens/administration/i.user.row";

import {UserService} from "@/services/user.service";
import {AuthenticationService} from "@/services/authentication.service";
import {empty, fromMySQLDate} from "@/util/util";
import {ActivatedRoute, ParamMap} from "@angular/router";
import {Subscription} from "rxjs";

@Component({
  standalone: false,
  templateUrl: 'user.profile.component.html'
})

/**
 *
 * @class UserProfileComponent
 *
 * @brief specific user profile page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class UserProfileComponent implements OnInit {

  /** the logged in user */
  public viewer: User               = null;

  /** the user profile being viewed */
  public user: IUserRow             = null;

  /** the user's profile pic / avatar, if there is one */
  public profilePic: string         = '<img class="profile-icon" src="assets/images/profile-512.png">';

  /** our subscription to the current route */
  private routeListen: Subscription = null;

  /** the userid of the user being viewed */
  private userid: string            = '';

  /** standard constructor */
  constructor(
    private auth:  AuthenticationService,
    private users: UserService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {

  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[UserProfileComponent] init...');

    let upc: UserProfileComponent = this;

    /* who is viewing the page */

    upc.viewer = upc.auth.userOfSession;

    upc.routeListen = upc.route.paramMap.subscribe((params: ParamMap) => {

      /* figure out the 'key' ... */

      upc.userid = params.get('id');

      /* fetch the project... */

      upc.refresh();

    });

  }

  refresh(): void {

    let upc: UserProfileComponent = this;

    Logger.debug(`[UserProfileComponent] refreshing on '${upc.userid}'...`);

    /* fetch the user being viewed */

    upc.users.userByUserid(upc.userid)
      .pipe(first())
      .subscribe({
        next: (data: any): void => {

          let row: IUserRow = null;

          if (typeof data.result == "undefined") {

            Logger.debug('[UserProfileComponent] garbled user data?: ', data);

            return;
          }

          upc.user            = data.result;

          upc.user.created_at = fromMySQLDate(upc.user .created_at).toLocaleString().slice(0, 19).replace(',', '');
          upc.user.updated_at = fromMySQLDate(upc.user .updated_at).toLocaleString().slice(0, 19).replace(',', '');

          upc.profilePic      = !!upc.user.icon ? `<img class="profile-icon" src="${upc.user.icon}">`  : '<img class="profile-icon" src="assets/images/profile-512.png">';

          upc.cdRef.detectChanges();

        },
        error: (error: any): void => {

          Logger.debug('[UserProfileComponent] could not fetch user details: ', error);
        }

      });
  }

}

